import { applyCascateTicketSubItemStatusChange } from './applyCascateTicketSubItemStatusChange';
import { IDisplayTicketItem } from '../interfaces/IDisplayTicket';
import { OrderStatusEnum } from '../enums/OrderStatusEnum';

export function applyCascateTicketItemStatusChange(
  items: IDisplayTicketItem[],
  status: OrderStatusEnum
): IDisplayTicketItem[] {
  return (
    items?.map((item) => {
      const { subitems } = item;

      return {
        ...item,
        status,
        ...(subitems?.length > 0 && {
          subitems: applyCascateTicketSubItemStatusChange(subitems, status),
        }),
      };
    }) || []
  );
}
